/**
 * Returns true if the course has a non-free price.
 * @param {string|number} price - Course price from Firestore (e.g. 'Free', 0, 5000, '₦5,000', 'Paid')
 */
export function isPaidCourse(price) {
  if (price == null || price === '') return false;
  if (typeof price === 'number') return price > 0;
  if (typeof price === 'string') {
    const trimmed = price.trim();
    if (trimmed.toLowerCase() === 'free') return false;
    if (trimmed.toLowerCase() === 'paid') return true;
    const num = parseFloat(trimmed.replace(/[^0-9.]/g, ''));
    return !Number.isNaN(num) && num > 0;
  }
  return false;
}

/**
 * Format price for display: "Free", "Paid", or the amount (e.g. "₦5,000").
 * If price is already a string with currency, return as-is; otherwise format number.
 */
export function formatCoursePrice(price) {
  if (price == null || price === '') return 'Free';
  if (typeof price === 'number') return price === 0 ? 'Free' : `₦${Number(price).toLocaleString()}`;
  if (typeof price === 'string') {
    const trimmed = price.trim();
    if (trimmed.toLowerCase() === 'free') return 'Free';
    if (trimmed.toLowerCase() === 'paid') return 'Paid';
    const num = parseFloat(trimmed.replace(/[^0-9.]/g, ''));
    if (Number.isNaN(num) || num === 0) return 'Free';
    if (/^[₦$€£]|NGN|USD/i.test(trimmed)) return trimmed;
    return `₦${num.toLocaleString()}`;
  }
  return 'Free';
}
